import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withConsumer, scenarioNames } from '../util/constants';

class DismissBtnBase extends React.Component {
  handleDismiss = () => {
    const {
      id,
      dismissAction,
      content,
      logger,
      logContent,
    } = this.props;
    dismissAction(id);
    logger.trace(scenarioNames.CommonDismiss, logContent(`id=${id}, content=${content}`));
  };

  render() {
    return (
      <button
        tabIndex="0"
        className={classNames('notification-queue-item-dismiss', 'close', 'dismiss', 'closeimage', 'disableEsc', 'clickable')}
        onClick={this.handleDismiss}
      />
    );
  }
}

DismissBtnBase.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  dismissAction: PropTypes.func,
  content: PropTypes.string,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
};

DismissBtnBase.defaultProps = {
  dismissAction: _.noop,
  content: '',
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
};

export const DismissBtn = withConsumer(DismissBtnBase);
